import { observable, toJS } from "mobx";

class PersonnelSignupStore {
  @observable userInfo = {};
  @observable userInfoData = {};

  constructor() {
    this.getUserDetails();
  }

  setUserDetails = udata => {
    // console.log("udata", udata);
    // let format = {token: "abcd", data: {}}     //Format in which user data is saving in local storage.
    localStorage.setItem("userData", JSON.stringify(udata));
  };

  getUserDetails = () => {
    const usrDataFrmLs = localStorage.getItem("userData");
    this.userInfo = JSON.parse(usrDataFrmLs);
    // console.log("", JSON.parse(usrDataFrmLs), this.userInfo);
    return this.userInfo;
  };

  setUserDetSignupData = usr => {
    // console.log("usr", usr);
    this.userInfoData = usr;
    // console.log("Per-usr", toJS(this.userInfoData));
  };

  getUserDetSignupData = () => {
    // console.log("Store data: ", toJS(this.userInfoData));
    return this.userInfoData;
  };
}

export default PersonnelSignupStore;
